module.exports = __webpack_public_path__ + "static/media/Vector.488ea187.svg";